import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Input } from 'reactstrap';
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import { Link } from 'react-router-dom';
import { Breadcrumbs, Image, P, H4, H6, Btn, UL } from '../../../AbstractElements';
import ProjectContext from '../../../_helper/Project';
import CustomizerContext from '../../../_helper/Customizer';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from "react-toastify";
import EmailContext from '../../../_helper/Email';
import smiling_lady from '../../../assets/images/smiling_lady.png';
import DRTSSearchBox from './DRTSSearchBox';



const DRTSHome = () => { 
  const { layoutURL } = useContext(CustomizerContext);
  const [activeTab, setActiveTab] = useState('1');
  const [searchresponsive, setSearchresponsive] = useState();


  
const SeacrhResposive = (searchresponsive) => {
  if (searchresponsive) {
    setSearchresponsive(!searchresponsive);
    document.querySelector('.search-full').classList.add('open');
    document.querySelector('.more_lang').classList.remove('active');
  } else {
    setSearchresponsive(!searchresponsive);
    document.querySelector('.search-full').classList.remove('open');
  }
};

  return (
    <Fragment>
      <Breadcrumbs />
      <Container fluid={true}>

      <Row className="project-card" style={{width:"100%",textAlign:"center", padding:0, margin:0}}>
          <Col md="12" className="project-list" style={{width:"100%",textAlign:"center", margin:0, padding:0}}>
          
          <Row style={{textAlign:"center", padding:"5px", width:"100%"}}>
            
          <Col md='3' style={{textAlign:"center", width:"25%", backgroundColor:"ffffff"}}>{" "}
         {/*} <span className='header-search'> 
        <SvgIcon iconId='search' onClick={() => SeacrhResposive(searchresponsive)} />
      </span>*/}
          
          </Col>
          <Col md='6' style={{textAlign:"center", width:"50%", backgroundColor:"#ffffff", padding:5, borderRadius: "0.7rem"}}>			 
           
               {/* <Input  name='search_main' onClick={() => SeacrhResposive(searchresponsive)} className="form-control input_bodara" type="text" placeholder='Search DRTS ..' style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
               */}  
               
          
               <DRTSSearchBox />  
             

          </Col>

          <Col md='3' style={{textAlign:"center", width:"25%", backgroundColor:"ffffff"}}>{" "}
          </Col>

          </Row> 

          </Col>
        </Row>
  
		
		 <Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row style={{width:"100%"}}>
                <Col md="5" style={{ width:"40%", textAlign:"center"}}>
                
                 <Image attrImage={{ src: `${smiling_lady}`, 
                 alt: 'Welcome to DRTS Web Portal', width:430, 
                 border: '1px solid white', borderRadius:"0.7rem", textAlign: "center", margin:0 }} />
                           
                </Col>
				
				        <Col md="7" style={{width:"60%", backgroundColor:"#ffffff"}}>
                   <Nav tabs className="border-tab">
                    
                    <NavItem><NavLink className={'active'} ><H4>{"Experience our new commitment to serve you!"}</H4></NavLink></NavItem>                    
				            </Nav>

                    <div style={{marginLeft:5, minWidth: "300px", textAlign:'left', width:'100%', border: '1px solid white', borderRadius:"0.7rem", color:'#888888', align:'left'}}>
                    {"Through this web portal, you can access services offered by the Department of Road Transport Services (DRTS) from the comfort of your computer."}
                    <br /><br />
                    {"We are committed to bringing you convenience, prompt service and peace of mind."}
                  </div>
                </Col>
               
              </Row>
            </Card> 
          </Col>
          <Col sm="12">
            <Card >
              <CardBody>
                <TabContent activeTab={activeTab} >
                  
                  <TabPane tabId="1" style={{padding:"0px"}}>
                    <Row >
                      
                        <div style={{textAlign:'center', width:'100%', color:'#5fabcc',fontWeight:'bold', align:'center'}}>
                               {"Featured eServices"}</div>

              <div style={{margin:"0px", padding:"0px", textAlign:'center', width:'100%', align:'center'}}>

    <Card className='course-card' style={{textAlign:'center',width:"100%", padding:"0px", align:'center'}}>      
      <CardBody className='pt-0' style={{textAlign:'center',width:"100%", padding:"0px", align:'center'}}>
        <div className='course-main-card' style={{textAlign:'center',width:"100%", padding:"0px", align:'center'}}>
        <Row style={{textAlign:'center',width:"100%", padding:"0px", align:'center'}}>
    
     <Col md="3" style={{backgroundColor:"#ffffff", width:"250", padding:"0px"}}>
      <div className='course-wrapper' style={{backgroundColor:"#5fabcc", margin:"5px", width:"250", padding:"0px"}}>

      <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices"> 
                  
      <div className='course-icon-box' style={{backgroundColor:"#ffffff", width:"250"}}>
        <div className='icon-wrap'>
        <Image attrImage={{ className: 'arrow-bg', src: require(`../../../assets/images/drts_home/test_booking.png`), alt: 'Access DRTS eServices', width:'250' }} />
      </div>
         </div>
        <div className='icon-wrap' style={{ width:"250"}}>
          <Image attrImage={{ src: require(`../../../assets/images/drts_home/click_ico_blue.png`), alt: 'clock vector', width:'30' }} />
        </div>
        <div style={{backgroundColor:"#5fabcc", color:"#e0f1f8", fontSize:"18", padding:"4px", width:"100%"}}>
          {"Book for "}{"Theory Test"}</div>
          </Link>
    </div>
    </Col>
<Col md="3" style={{backgroundColor:"#ffffff", width:"250", padding:"0px"}}>
    <div className='course-wrapper' style={{backgroundColor:"#5fabcc", margin:"5px", width:"250", padding:"0px"}}>
    <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices"> 
      <div className='course-icon-box' style={{backgroundColor:"#ffffff", width:"250"}}>
        <div className='icon-wrap'>
        <Image attrImage={{ className: 'arrow-bg', src: require(`../../../assets/images/drts_home/lekgetho_renewal.png`), alt: 'Access DRTS eServices', width:'250' }} />
       </div>
        </div>
      <div className='icon-wrap' style={{ width:"250"}}>
          <Image attrImage={{ src: require(`../../../assets/images/drts_home/click_ico_blue.png`), alt: 'clock vector', width:'30' }} />
        </div>
      <div style={{backgroundColor:"#5fabcc", color:"#e0f1f8", fontSize:"18", padding:"4px", width:"100%"}}>
        {"Renew "}{"Vehicle License (Lekgetho)"}</div>
        </Link>
    </div>
    </Col>
<Col md="3" style={{backgroundColor:"#ffffff", width:"250", padding:"0px"}}>
    <div className='course-wrapper' style={{backgroundColor:"#5fabcc", margin:"5px", width:"250", padding:"0px"}}>
    <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices"> 
      <div className='course-icon-box' style={{backgroundColor:"#ffffff", width:"250"}}>
        <div className='icon-wrap'>
        <Image attrImage={{ className: 'arrow-bg', src: require(`../../../assets/images/drts_home/driving_licenses.png`), alt: 'Access DRTS eServices', width:'250' }} />
        </div>
         </div>
      <div className='icon-wrap' style={{ width:"250"}}>
          <Image attrImage={{ src: require(`../../../assets/images/drts_home/click_ico_blue.png`), alt: 'clock vector', width:'30' }} />
        </div>
      <div style={{backgroundColor:"#5fabcc", color:"#e0f1f8", fontSize:"18", padding:"4px", width:"100%"}}>
        {"Renew "}{"Driving License"}</div>
        </Link>
    </div>
</Col>
<Col md="3" style={{backgroundColor:"#ffffff", width:"250", padding:"0px"}}>
    <div className='course-wrapper' style={{backgroundColor:"#5fabcc", margin:"5px", width:"250", padding:"0px"}}>
    <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices"> 
      <div className='course-icon-box' style={{backgroundColor:"#ffffff", width:"250"}}>
        <div className='icon-wrap'>
        <Image attrImage={{ className: 'arrow-bg', src: require(`../../../assets/images/drts_home/car_testing.png`), alt: 'Access DRTS eServices', width:'250' }} />
      </div>
      </div>
      <div className='icon-wrap' style={{ width:"250"}}>
          <Image attrImage={{ src: require(`../../../assets/images/drts_home/click_ico_blue.png`), alt: 'clock vector', width:'30' }} />
      </div>
      <div style={{backgroundColor:"#5fabcc", color:"#e0f1f8", fontSize:"18", padding:"4px", width:"100%"}}>
        {"Book for "}{"Roadworthiness Test"}</div>
        </Link>
    </div>

    </Col>
    </Row>

    </div>
      </CardBody>
    </Card>                     
   
              </div>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
		
		
		
		
		
		
      </Container>
    </Fragment>
  );
};

export default DRTSHome;